import { useMutation } from 'react-query';
import {
  getVehicleFragaByChassi,
  getVehicleFragaList,
} from './Vehicle.service';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import notificationError from '@/utils/functions/notificationError';
import { VehicleErros } from './Vehicle.dicionary';

export function useVehicleFragaList() {
  const hasPermission = hasPermissions([Authorities.DEFAULT_INTEGRATION_FRAGA]);

  return useMutation(
    (variables: string) =>
      hasPermission ? getVehicleFragaList(variables) : Promise.resolve(null),
    {
      onError(error) {
        notificationError(error, {
          translate: (errors) =>
            errors.map((err) => VehicleErros[err.split(':')[0]] || err),
        });
      },
    },
  );
}

export function useVehicleFragaByChassi() {
  const hasPermission = hasPermissions([Authorities.DEFAULT_INTEGRATION_FRAGA]);

  return useMutation(
    (chassi: string) =>
      hasPermission ? getVehicleFragaByChassi(chassi) : Promise.resolve(null),
    {
      onError(error) {
        notificationError(error, {
          translate: (errors) =>
            errors.map((err) => VehicleErros[err.split(':')[0]] || err),
        });
      },
    },
  );
}
